import i18n from "i18next"
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import Backend from 'i18next-http-backend';
import { initReactI18next } from "react-i18next"
import Modal from 'react-modal'
import { treaty } from "@elysiajs/eden"
import { App as Server } from 'rin-server/src/server'
import App from './App'
import './index.css'
import './components.css'
import { listenSystemMode } from './utils/darkModeUtils'
import LanguageDetector from 'i18next-browser-languagedetector';
import { Seo } from './components/seo';
import { apiUrl } from './utils/constants';

// Use centralized API URL from constants / environment
export const endpoint = apiUrl
export const oauth_url = `${endpoint}/user/github`
export const client = treaty<Server>(endpoint, {
  fetcher: (input, init = {}) => {
    return fetch(input, {
      ...init,
      credentials: 'include'
    })
  }
})



// Clean up legacy service workers and caches from previous site deployments
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  }).catch(() => {});
  if ('caches' in window) {
    caches.keys().then((keys) => {
      for (const key of keys) {
        caches.delete(key);
      }
    }).catch(() => {});
  }
}

listenSystemMode()
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <Seo />
      <App />
    </HelmetProvider>
  </React.StrictMode>
)
Modal.setAppElement('#root');
